import { useContext, useEffect, useState } from "react";

import iChange from "../../../assets/images/100-change.svg";
import iEye from "../../../assets/images/100-eye-black.svg";
import iEyeGrya from "../../../assets/images/100-eye-disable-gray.svg";
import iconExitFullScreen from "../../../assets/images/exit-full-screen.svg";
import iOsUbuntu from "../../../assets/images/os-ubuntu.svg";
import MeetingThumbVideos from "../../../components/meeting-tumb-cams";
import Whiteboarding from "../../../components/whiteboarding";
import { useGlobal } from "../../../contexts/globalContext";
// import { SocketContext } from "../../../contexts/socketContext";
import { useHttpMethods } from "../../../hooks/useHttpMethods";
import VideConference from "../../meeting/details/video-conference";
import IOInputs from "../io-inputs";

const TopBar = ({ allControllerElementsVisibility, updateAllControllerElementsVisibility, exitFullscreen }) => {
  const { get } = useHttpMethods();
  const [isHidden, setIsHidden] = useState(false);
  // const { socket } = useContext(SocketContext);
  const { MEETING_STATE, SCREEN_SWITCH_PROGGRESS, SCREEN_SWITCH_STEP, SET_SCREEN_SWITCH_PROGGRESS, SET_SCREEN_SWITCH_STEP } = useGlobal();

  const [showVideoConference, setShowVideoConference] = useState(false);
  const [videoConferenceMode, setVideoConferenceMode] = useState("camera");
  const [fullScreenCount, setFullScreenCount] = useState(0);

  const hidePopUp = () => {
    setShowVideoConference(false);

    document.querySelector(".top-bar-left").classList.remove("v-h");
    document.querySelector(".controler-items-contaner").classList.remove("v-h");
    document.querySelector(".fn__top-bar-right").classList.remove("v-h");
    document.querySelector("footer.footer").classList.remove("hide");

    localStorage.setItem("showVideoConferance", false);
  };

  const handleOutsideClick = (e) => {
    if (e.target.className === "video-confrance-section") hidePopUp();
  };

  const hideItems = () => {
    document.querySelector(".top-bar-left").classList.add("v-h");
    document.querySelector(".controler-items-contaner").classList.add("v-h");
    document.querySelector(".fn__top-bar-right").classList.add("v-h");
    document.querySelector("footer.footer").classList.add("hide");
  };

  const handleThumbClick = () => {
    localStorage.setItem("showVideoConferance", !showVideoConference);

    setShowVideoConference(!showVideoConference);
    setVideoConferenceMode("camera");

    hideItems();
  };

  const handleSettingClick = () => {
    localStorage.setItem("showVideoConferance", !showVideoConference);

    setShowVideoConference(!showVideoConference);
    setVideoConferenceMode("settings");
    hideItems();
  };

  const handleDualFullScreenClick = async () => {
    await get("https://gx143.lab.bgigs.com/dual_full_screen_switch");
  };

  useEffect(() => {
    const handleFullScreenCountChanged = (payload) => setFullScreenCount(payload);

    const handleDualFullScreenSwitchChanged = () => {
      setShowVideoConference((pp) => {
        if (pp) {
          hidePopUp();

          return false;
        }

        hideItems();

        return true;
      });
    };

    // socket.on("full_screen_count_changed", handleFullScreenCountChanged);
    // socket.on("dual_full_screen_switch_changed", handleDualFullScreenSwitchChanged);

    return () => {
      // socket.off("full_screen_count_changed", handleFullScreenCountChanged);
      // socket.off("dual_full_screen_switch_changed", handleDualFullScreenSwitchChanged);
    };
  }, []);

  useEffect(() => {
    if (!allControllerElementsVisibility) setIsHidden(false);
  }, [allControllerElementsVisibility]);

  const hideTopBarHandler = () => {
    setIsHidden(!isHidden);
  };

  const openTileView = () => {
    if (SCREEN_SWITCH_STEP.step !== "WAITING") return;
    setIsHidden(!isHidden);
    updateAllControllerElementsVisibility(false);
  };

  useEffect(() => {
    SCREEN_SWITCH_STEP.step === "WAITING" && SET_SCREEN_SWITCH_PROGGRESS(0);
  }, [SCREEN_SWITCH_STEP.step]);

  useEffect(() => {
    if (SCREEN_SWITCH_PROGGRESS === 100) {
      SET_SCREEN_SWITCH_STEP((prev) => ({
        ...prev,
        step: "WAITING",
      }));
    }
  }, [SCREEN_SWITCH_PROGGRESS]);

  return (
    <>
      <div className="fn__eye m-lr-10">
        <div onClick={hideTopBarHandler}>
          <img src={isHidden ? iEyeGrya : iEye} className="i i-32 i-eye-hidden" alt="observe" id="tooltip-a1" />
          {isHidden && (
            <div className="fg-tooltip top-left" id="tooltip-0">
              Show Tools
            </div>
          )}
        </div>
        {fullScreenCount > 1 ? <button onClick={handleDualFullScreenClick}>Dual Full Screen</button> : null}
      </div>
      <div className={isHidden ? "hide" : "fn__top-bar top-bar"}>
        <div className="top-bar-left">
          <div className="change-screen-item">
            <div className="flex-col align-center">
              <img src={iOsUbuntu} width={20} height={20} alt="" />
              <span className="C2-Medium fg-text-white w-50 center"> 1920x1080 </span>
            </div>
            <div className="divider-vertical m-lr-10" />
            <div className="flex-col space-between" id="screen-name">
              <span className="C1-Medium fg-text-white three-dot"> Screen1 </span>
              <span className="B3-Medium fg-text-white"> macOS Big Sur </span>
            </div>
            <button onClick={openTileView} className="m-l-10 icon-action">
              {SCREEN_SWITCH_STEP.step !== "WAITING" && (
                <span
                  className="progress-circle"
                  style={{
                    background: `radial-gradient(closest-side, white 79%, transparent 80% 100%), conic-gradient(#0075FF ${SCREEN_SWITCH_PROGGRESS}%, transparent 0)`,
                  }}
                />
              )}
              <img src={iChange} width={32} height={32} className="i-tile" alt="" />
            </button>
          </div>

          <Whiteboarding />
        </div>

        <div className="top-bar-center">
          <IOInputs />
        </div>

        <div className="top-bar-right">
          <div className="fn__top-bar-right">
            <div className="fn__btn-settings" onClick={handleSettingClick} />
            <div className="list-small-thumbnails pointer" onClick={handleThumbClick}>
              {/* dev-mode-fn */}
              <MeetingThumbVideos meetingState={MEETING_STATE} />
            </div>

            {/** * btn close ** */}
            <div className="exit-full-screen m-lr-10">
              <img src={iconExitFullScreen} onClick={exitFullscreen} className="btn-32 btn-exit-full-screen" alt="exit-full-screen" />
            </div>
          </div>

          {showVideoConference && <VideConference onOutsideClick={handleOutsideClick} videoConferanceMode={videoConferenceMode} />}
        </div>
      </div>
    </>
  );
};

export default TopBar;
